import { render, staticRenderFns } from "./AffidavitStep.vue?vue&type=template&id=994c5112"
import script from "./AffidavitStep.vue?vue&type=script&lang=ts"
export * from "./AffidavitStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports